// app/javascript/packs/vpc_form.js

document.addEventListener('turbolinks:load', () => {
    const form       = document.getElementById('vpc-form')
    if (!form) return

    // Inject animations once
    if (!document.getElementById('vpc-form-animation-styles')) {
      const style = document.createElement('style')
      style.id = 'vpc-form-animation-styles'
      style.textContent = `
        @keyframes pulse-error {
          0%   { box-shadow: 0 0 0 0 rgba(220,38,38,0.7); }
          50%  { box-shadow: 0 0 0 8px rgba(220,38,38,0.5); }
          100% { box-shadow: 0 0 0 0 rgba(220,38,38,0); }
        }
        .highlight-error {
          animation: pulse-error 1s ease-out;
        }
        @keyframes button-press {
          0%   { transform: scale(1); }
          50%  { transform: scale(0.97); }
          100% { transform: scale(1); }
        }
        .animate-press {
          animation: button-press 0.2s ease-in-out;
        }
      `
      document.head.appendChild(style)
    }

    // Fields
    const nameFld    = document.getElementById('vpc-name')
    const addrFld    = document.getElementById('vpc-address')
    const emailFld   = document.getElementById('vpc-email')
    const prefField  = document.getElementById('preference-field')
    const ownerChk   = document.getElementById('vpc-owner-confirmation')
    const submitBtn  = document.getElementById('vpc-submit')
    const buttons    = Array.from(form.querySelectorAll('.js-pref-btn'))

    // Error containers
    const errors = {
      name:       document.getElementById('vpc-name-error'),
      address:    document.getElementById('vpc-address-error'),
      email:      document.getElementById('vpc-email-error'),
      preference: document.getElementById('vpc-preference-error'),
      owner:      document.getElementById('vpc-owner-error')
    }

    // Helpers
    function clearError(fld, errEl) {
      fld.classList.remove('border-red-600', 'highlight-error')
      errEl.textContent = ''
      errEl.classList.add('hidden')
    }

    function showError(fld, errEl, msg) {
      fld.classList.add('border-red-600', 'highlight-error')
      errEl.textContent = msg
      errEl.classList.remove('hidden')
    }

    function validate() {
      let valid = true

      clearError(nameFld, errors.name)
      if (!nameFld.value.trim()) {
        showError(nameFld, errors.name, 'Name is required')
        valid = false
      }

      clearError(addrFld, errors.address)
      if (!addrFld.value.trim()) {
        showError(addrFld, errors.address, 'Unit address is required')
        valid = false
      }

      clearError(emailFld, errors.email)
      const emailVal = emailFld.value.trim()
      if (!emailVal) {
        showError(emailFld, errors.email, 'Email is required')
        valid = false
      } else if (!/\S+@\S+\.\S+/.test(emailVal)) {
        showError(emailFld, errors.email, 'Enter a valid email')
        valid = false
      }

      clearError(prefField, errors.preference)
      if (!prefField.value) {
        showError(prefField, errors.preference, 'Please choose Paper or Electronic')
        valid = false
      }

      clearError(ownerChk, errors.owner)
      if (!ownerChk.checked) {
        showError(ownerChk, errors.owner, 'You must confirm you are the owner of record')
        valid = false
      }

      return valid
    }

    function scrollToError() {
      const field = form.querySelector('.border-red-600')
      if (field) {
        field.scrollIntoView({ behavior: 'smooth', block: 'center' })
        field.focus({ preventScroll: true })
      }
    }

    // Button toggle + press animation
    buttons.forEach(button => {
      button.addEventListener('click', () => {
        prefField.value = button.dataset.preference

        buttons.forEach(btn => {
          btn.classList.remove('bg-indigo-600','text-white','hover:bg-indigo-700')
          btn.classList.add   ('bg-white','text-gray-800','border-gray-300','hover:shadow-md')
        })

        button.classList.remove('bg-white','text-gray-800','border-gray-300','hover:shadow-md')
        button.classList.add   ('bg-indigo-600','text-white','hover:bg-indigo-700')

        // soft press
        button.classList.add('animate-press')
        setTimeout(() => button.classList.remove('animate-press'), 200)

        clearError(prefField, errors.preference)
      })
    })

    // Clear owner error on change
    ownerChk.addEventListener('change', () => {
      if (ownerChk.checked) clearError(ownerChk, errors.owner)
    })

    // Per-field listeners to clear when fixed
    nameFld.addEventListener('input', () => {
      if (nameFld.value.trim()) clearError(nameFld, errors.name)
    })
    addrFld.addEventListener('input', () => {
      if (addrFld.value.trim()) clearError(addrFld, errors.address)
    })
    emailFld.addEventListener('input', () => {
      if (/\S+@\S+\.\S+/.test(emailFld.value.trim())) clearError(emailFld, errors.email)
    })

    // On submit
    submitBtn.addEventListener('click', e => {
      if (!validate()) {
        e.preventDefault()
        scrollToError()
      }
    })
  })
